import Locale from '@/modules/user/Enum/Locale';

class NavigatorHelper {
  private navigator: Navigator;

  constructor() {
    this.navigator = window.navigator;
  }

  getUserLanguage(): string {
    if (this.isUserLanguageFrench()) {
      return Locale.FRENCH.key;
    }

    if (this.isUserLanguageEnglish()) {
      return Locale.ENGLISH.key;
    }

    return this.navigator.language;
  }

  isUserLanguageFrench(): boolean {
    return this.navigator.language.startsWith('fr');
  }

  isUserLanguageEnglish(): boolean {
    return this.navigator.language.startsWith(Locale.ENGLISH.key);
  }
}

export default new NavigatorHelper();
